<div>
  <form [formGroup]="stepFormGroup" class="step-container">
    <h3><strong>Movimientos Anteroposteriores (AP)</strong></h3>
    <mat-card class="card-general">
      <mat-card-title>Incisivos Superiores</mat-card-title>
      <mat-card-content class="w-100 mt-2">
        <div class="row w-100">
          <div class="col-12 col-lg-10">
            <div class="w-100 row justify-content-start">
              <p class="col-12 col-sm-2 text-start">Posici&oacute;n:</p>
              <mat-radio-group aria-label="Seleciona una opción" formControlName="upperIncisorsPosition" class="col-12 col-sm-6 d-flex flex-wrap flex-sm-nowrap gap-4">
                <div class="row" *ngFor="let item of positionTypeOptions; index as i">
                  <mat-radio-button [value]="item.value"
                                    [checked]="item.value == getControl(stepFormGroup,'upperIncisorsPosition')" class="col-4"><span class="responsive-white-space">{{item.display}}</span></mat-radio-button>
                  <div class="col-8 pb-5">
                    <p class="text-justify w-fit mx-auto" style="max-width: 350px;">
                      {{item.description}}
                    </p>
                  </div>
                </div>
              </mat-radio-group>
            </div>

            <div class="w-100 row justify-content-start">
              <p class="col-12 col-sm-2 text-start">Torque:</p>
              <mat-radio-group aria-label="Seleciona una opción" formControlName="upperIncisorsTorque" class="col-12 col-sm-6 d-flex flex-wrap flex-sm-nowrap gap-4">
                <div class="row" *ngFor="let item of torqueUpperTypeOptions; index as i">
                  <mat-radio-button [value]="item.value"
                                    [checked]="item.value == getControl(stepFormGroup,'upperIncisorsTorque')" class="col-12 col-sm-4"><span class="responsive-white-space">{{item.display}}</span></mat-radio-button>
                  <div class="col-12 col-sm-8 pb-5">
                    <p class="text-justify w-fit mx-auto" style="max-width: 350px;">
                      {{item.description}}
                    </p>
                  </div>
                </div>
              </mat-radio-group>
            </div>
          </div>
          <div class="col-12 col-lg-2 text-center">
            <div class="col-12">
              <img style="max-width: 200px;" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-images/prescription/Dientes-14.svg" />
            </div>
          </div>
        </div>

      </mat-card-content>
    </mat-card>

    <mat-card class="card-general">
      <mat-card-title>Incisivos Inferiores</mat-card-title>
      <mat-card-content class="w-100 mt-2">
        <div class="row w-100">
          <div class="col-12 col-lg-10">
            <div class="w-100 row justify-content-start">
              <p class="col-12 col-sm-2 text-start">Posici&oacute;n:</p>
              <mat-radio-group aria-label="Seleciona una opción" formControlName="lowerIncisorsPosition" class="col-12 col-sm-6 d-flex flex-wrap flex-sm-nowrap gap-4">
                <div class="row" *ngFor="let item of positionTypeOptions; index as i">
                  <mat-radio-button [value]="item.value"
                                    [checked]="item.value == getControl(stepFormGroup,'lowerIncisorsPosition')" class="col-4"><span class="responsive-white-space">{{item.display}}</span></mat-radio-button>
                  <div class="col-8 pb-5">
                    <p class="text-justify w-fit mx-auto" style="max-width: 350px;">
                      {{item.description}}
                    </p>
                  </div>
                </div>
              </mat-radio-group>
            </div>

            <div class="row w-100 justify-content-start">
              <p class="col-12 col-sm-2 text-start">Torque:</p>
              <mat-radio-group aria-label="Seleciona una opción" formControlName="lowerIncisorsTorque" class="col-12 col-sm-6 d-flex flex-wrap flex-sm-nowrap gap-4">
                <div class="row" *ngFor="let item of torqueLowerTypeOptions; index as i">
                  <mat-radio-button [value]="item.value"
                                    [checked]="item.value == getControl(stepFormGroup,'lowerIncisorsTorque')" class="col-4"><span class="responsive-white-space">{{item.display}}</span></mat-radio-button>
                  <div class="col-8 pb-5">
                    <p class="text-justify w-fit mx-auto" style="max-width: 350px;">
                      {{item.description}}
                    </p>
                  </div>
                </div>
              </mat-radio-group>
            </div>
          </div>
          <div class="col-12 col-lg-2 text-center">
            <div class="col-12">
              <img style="max-width: 200px;" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-images/prescription/Dientes-15.svg" />
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="card-general">
      <mat-card-title>Anclaje en caso de extracciones</mat-card-title>
      <mat-card-content class="w-100 mt-2">
        <div class="mb-3 row w-100 justify-content-start">
          <p class="col-12 col-lg-3 text-start">Anclaje Posteriores Superiores:</p>
          <mat-radio-group aria-label="Seleciona una opción" formControlName="upperRearAnchorage" class="col-12 col-lg-7 d-flex flex-wrap flex-sm-nowrap gap-4">
            <div class="row" *ngFor="let item of positionTypeExtractionsOptions; index as i">
              <mat-radio-button [value]="item.value"
                                [checked]="item.value == getControl(stepFormGroup,'upperRearAnchorage')" class="col-4"><span class="responsive-white-space">{{item.display}}</span></mat-radio-button>
              <div class="col-8 pb-5">
                <p class="text-justify w-fit mx-auto" style="max-width: 350px;">
                  {{item.description}}
                </p>
              </div>
            </div>
          </mat-radio-group>
          <div class="col-12 col-lg-2 text-center">
            <div class="col-12">
              <img style="max-width: 200px;" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-images/prescription/Arcadas%20individuales-19.svg" />
            </div>
          </div>
        </div>

        <div class="row w-100 justify-content-start">
          <p class="col-12 col-lg-3 text-start">Anclaje Posteriores Inferiores:</p>
          <mat-radio-group aria-label="Seleciona una opción" formControlName="lowerRearAnchorage" class="col-12 col-lg-7 d-flex flex-wrap flex-sm-nowrap gap-4">
            <div class="row" *ngFor="let item of positionTypeExtractionsOptions; index as i">
              <mat-radio-button [value]="item.value"
                                [checked]="item.value == getControl(stepFormGroup,'lowerRearAnchorage')" class="col-4"><span class="responsive-white-space">{{item.display}}</span></mat-radio-button>
              <div class="col-8 pb-5">
                <p class="text-justify w-fit mx-auto" style="max-width: 350px;">
                  {{item.description}}
                </p>
              </div>
            </div>
          </mat-radio-group>
          <div class="col-12 col-lg-2 text-center">
            <div class="col-12">
              <img style="max-width: 200px;" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-images/prescription/Arcadas%20individuales-22.svg" />
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="card-general">
      <mat-card-title>Sobremordida Horizontal</mat-card-title>
      <mat-card-content class="mt-2 d-flex flex-column gap-5">
        <div class="row w-100 w-sm-75 justify-content-start">
          <mat-radio-group aria-label="Seleciona una opción" formControlName="horizontalOverbiteType" class="col d-flex flex-wrap flex-sm-nowrap flex-column gap-4">
            <div class="d-flex align-items-center gap-4" *ngFor="let item of horizontalOverbiteTypeOptions">
              <mat-radio-button [value]="item.value" (click)="resetFormControl(stepFormGroup, 'horizontalOverbiteSpace')"
                                [checked]="item.value == getControl(stepFormGroup,'horizontalOverbiteType')" class="">
                <span class="responsive-white-space">{{item.display}}</span>
              </mat-radio-button>
              <mat-form-field style="width: fit-content; height: fit-content;" *ngIf="item.value == 2 && item.value == getControl(stepFormGroup,'horizontalOverbiteType')">
                <input matInput type="number" min="0" formControlName="horizontalOverbiteSpace" step="0.1">
              </mat-form-field>
              <span *ngIf="item.value == 2 && item.value == getControl(stepFormGroup,'horizontalOverbiteType')">mm</span>
            </div>
          </mat-radio-group>
        </div>
        <div class="row gy-3 w-100 align-items-center">
          <div class="col-12 col-lg-10 text-center">
            <textarea maxlength="620" matInput placeholder="Ingresar comentarios..." name="objectivesInAnteroposteriorComments" formControlName="objectivesInAnteroposteriorComments" style="height: 120px;"></textarea>
          </div>
          <div class="col-12 col-lg-2 text-center">
            <img style="max-width: 200px;" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-images/prescription/Dientes-13.svg" />
          </div>
        </div>
      </mat-card-content>
    </mat-card>


    <mat-card class="card-general">
      <mat-card-title>Relaci&oacute;n Canina</mat-card-title>
      <mat-card-content class="w-75 mt-2">
        <div class="row w-100 w-sm-75 justify-content-start">
          <p class="col-12 col-sm-6 text-start">Derecha/Mantener Relación Original:</p>
          <mat-radio-group aria-label="Seleciona una opción" formControlName="canineRelationshipMaintainOriginalRightRelationship" class="col-12 col-sm-6 d-flex flex-wrap flex-sm-nowrap gap-4">
            <div class="row" *ngFor="let item of booleanOptions; index as i">
              <mat-radio-button [value]="item.value"
                                [checked]="item.value == getControl(stepFormGroup,'canineRelationshipMaintainOriginalRightRelationship')" class="col-4"><span class="responsive-white-space">{{item.display}}</span></mat-radio-button>
              <div class="col-8 pb-5">
                <p class="text-justify w-fit mx-auto" style="max-width: 350px;">
                  {{item.description}}
                </p>
              </div>
            </div>
          </mat-radio-group>
        </div>

        <div class="row w-100 w-sm-75 justify-content-start" *ngIf="!getControl(stepFormGroup,'canineRelationshipMaintainOriginalRightRelationship')">
          <p class="col-12 col-sm-6 text-start">Llevar a:</p>
          <mat-radio-group aria-label="Seleciona una opción" formControlName="canineRelationshipRightRelationshipType" class="col-12 col-sm-6 d-flex flex-wrap flex-sm-nowrap gap-4">
            <div class="row" *ngFor="let item of classTypeOptions; index as i">
              <mat-radio-button [value]="item.value"
                                [checked]="item.value == getControl(stepFormGroup,'canineRelationshipRightRelationshipType')" class="col-4"><span class="responsive-white-space">{{item.display}}</span></mat-radio-button>
              <div class="col-8 pb-5">
                <p class="text-justify w-fit mx-auto" style="max-width: 350px;">
                  {{item.description}}
                </p>
              </div>
            </div>
          </mat-radio-group>
        </div>

        <div class="row w-100 w-sm-75 justify-content-start">
          <p class="col-12 col-sm-6 text-start">Izquierda/Mantener Relación Original:</p>
          <mat-radio-group aria-label="Seleciona una opción" formControlName="canineRelationshipMaintainOriginalLeftRelationship" class="col-12 col-sm-6 d-flex flex-wrap flex-sm-nowrap gap-4">
            <div class="row" *ngFor="let item of booleanOptions; index as i">
              <mat-radio-button [value]="item.value"
                                [checked]="item.value == getControl(stepFormGroup,'canineRelationshipMaintainOriginalLeftRelationship')" class="col-4"><span class="responsive-white-space">{{item.display}}</span></mat-radio-button>
              <div class="col-8 pb-5">
                <p class="text-justify w-fit mx-auto" style="max-width: 350px;">
                  {{item.description}}
                </p>
              </div>
            </div>
          </mat-radio-group>
        </div>

        <div class="row w-100 w-sm-75 justify-content-start" *ngIf="!getControl(stepFormGroup,'canineRelationshipMaintainOriginalLeftRelationship')">
          <p class="col-12 col-sm-6 text-start">Llevar a:</p>
          <mat-radio-group aria-label="Seleciona una opción" formControlName="canineRelationshipLeftRelationshipType" class="col-12 col-sm-6 d-flex flex-wrap flex-sm-nowrap gap-4">
            <div class="row" *ngFor="let item of classTypeOptions; index as i">
              <mat-radio-button [value]="item.value"
                                [checked]="item.value == getControl(stepFormGroup,'canineRelationshipLeftRelationshipType')" class="col-4"><span class="responsive-white-space">{{item.display}}</span></mat-radio-button>
              <div class="col-8 pb-5">
                <p class="text-justify w-fit mx-auto" style="max-width: 350px;">
                  {{item.description}}
                </p>
              </div>
            </div>
          </mat-radio-group>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="card-general">
      <mat-card-title>Relaci&oacute;n Molar</mat-card-title>
      <mat-card-content class="w-75 mt-2">
        <div class="row w-100 w-sm-75 justify-content-start">
          <p class="col-12 col-sm-6 text-start">Derecha/Mantener Relación Original:</p>
          <mat-radio-group aria-label="Seleciona una opción" formControlName="molarRelationshipMaintainOriginalRightRelationship" class="col-12 col-sm-6 d-flex flex-wrap flex-sm-nowrap gap-4">
            <div class="row" *ngFor="let item of booleanOptions; index as i">
              <mat-radio-button [value]="item.value"
                                [checked]="item.value == getControl(stepFormGroup,'molarRelationshipMaintainOriginalRightRelationship')" class="col-4"><span class="responsive-white-space">{{item.display}}</span></mat-radio-button>
              <div class="col-8 pb-5">
                <p class="text-justify w-fit mx-auto" style="max-width: 350px;">
                  {{item.description}}
                </p>
              </div>
            </div>
          </mat-radio-group>
        </div>

        <div class="row w-100 w-sm-75 justify-content-start" *ngIf="!getControl(stepFormGroup,'molarRelationshipMaintainOriginalRightRelationship')">
          <p class="col-12 col-sm-6 text-start">Llevar a:</p>
          <mat-radio-group aria-label="Seleciona una opción" formControlName="molarRelationshipRightRelationshipType" class="col-12 col-sm-6 d-flex flex-wrap flex-sm-nowrap gap-4">
            <div class="row" *ngFor="let item of classTypeOptions; index as i">
              <mat-radio-button [value]="item.value"
                                [checked]="item.value == getControl(stepFormGroup,'molarRelationshipRightRelationshipType')" class="col-4"><span class="responsive-white-space">{{item.display}}</span></mat-radio-button>
              <div class="col-8 pb-5">
                <p class="text-justify w-fit mx-auto" style="max-width: 350px;">
                  {{item.description}}
                </p>
              </div>
            </div>
          </mat-radio-group>
        </div>

        <div class="row w-100 w-sm-75 justify-content-start">
          <p class="col-12 col-sm-6 text-start">Izquierda/Mantener Relación Original:</p>
          <mat-radio-group aria-label="Seleciona una opción" formControlName="molarRelationshipMaintainOriginalLeftRelationship" class="col-12 col-sm-6 d-flex flex-wrap flex-sm-nowrap gap-4">
            <div class="row" *ngFor="let item of booleanOptions; index as i">
              <mat-radio-button [value]="item.value"
                                [checked]="item.value == getControl(stepFormGroup,'molarRelationshipMaintainOriginalLeftRelationship')" class="col-4"><span class="responsive-white-space">{{item.display}}</span></mat-radio-button>
              <div class="col-8 pb-5">
                <p class="text-justify w-fit mx-auto" style="max-width: 350px;">
                  {{item.description}}
                </p>
              </div>
            </div>
          </mat-radio-group>
        </div>

        <div class="row w-100 w-sm-75 justify-content-start" *ngIf="!getControl(stepFormGroup,'molarRelationshipMaintainOriginalLeftRelationship')">
          <p class="col-12 col-sm-6 text-start">Llevar a:</p>
          <mat-radio-group aria-label="Seleciona una opción" formControlName="molarRelationshipLeftRelationshipType" class="col-12 col-sm-6 d-flex flex-wrap flex-sm-nowrap gap-4">
            <div class="row" *ngFor="let item of classTypeOptions; index as i">
              <mat-radio-button [value]="item.value"
                                [checked]="item.value == getControl(stepFormGroup,'molarRelationshipLeftRelationshipType')" class="col-4"><span class="responsive-white-space">{{item.display}}</span></mat-radio-button>
              <div class="col-8 pb-5">
                <p class="text-justify w-fit mx-auto" style="max-width: 350px;">
                  {{item.description}}
                </p>
              </div>
            </div>
          </mat-radio-group>
        </div>
      </mat-card-content>
    </mat-card>
<div class="text-center">
  <p>Describe a grandes rasgos los puntos importantes en los movimientos de relación canina y molar (¿Cómo deseas solucionar la maloclusión?)</p>
  <textarea maxlength="620" matInput placeholder="Ingresar comentarios (Si no hay comentarios escribir sin comentarios)" name="relationshipsValuesComments" formControlName="relationshipsValuesComments" style="height: 120px;" [required]="true"></textarea>
  <mat-error *ngIf="stepFormGroup.get('relationshipsValuesComments').hasError('required')">Completa este campo.</mat-error>
</div>
   

    <div class="d-flex justify-content-center gap-4" *ngIf="isCaseDetail">
      <button mat-button matStepperPrevious class="button secondary-button"><mat-icon>chevron_left</mat-icon> Anterior</button>
      <button mat-button matStepperNext data-testid="nextStep5" class="button secondary-button" (click)="updateStepPrescription()" [disabled]="disabledButtonStages()">Guardar y Continuar <mat-icon>chevron_right</mat-icon></button>
    </div>
  </form>
</div>
